import { Fetch } from '@ekuaibao/fetch';
var languageMap = {
    'en-US': 'en',
    'zh-CN': 'cn'
};
export default function fnGetFieldLabel(field) {
    if (field === void 0) { field = {}; }
    var currentLanguagePrefix = languageMap[Fetch.lang || Fetch.defaultLanguage];
    return field[currentLanguagePrefix + "Label"] || i18n.get(field.label);
}
export function getPlaceholder(field) {
    if (field === void 0) { field = {}; }
    var currentLanguagePrefix = languageMap[Fetch.lang || Fetch.defaultLanguage];
    return field[currentLanguagePrefix + "Placeholder"] || field.placeholder || '';
}
